import types from "./types";

const INITIAL_STATE = {
  quotationList: null,
  quotationListError: null,
  quotationListLoading: false,

  //create
  createquotation: null,
  createquotationError: null,
  createquotationLoading: false,

  //update
  updatequotation: null,
  updatequotationError: null,
  updatequotationLoading: false,

  //delete
  deletequotation: null,
  deletequotationError: null,
  deletequotationLoading: false,

  //single item
  singleItem: null,
};

const quotationReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_QUOTATION_START:
      return {
        ...state,
        quotationList: null,
        quotationListError: null,
        quotationListLoading: true,
      };
    case types.GET_QUOTATION_SUCCESS:
      return {
        ...state,
        quotationList: action.payload,
        quotationListLoading: false,
      };
    case types.GET_QUOTATION_ERROR:
      return {
        ...state,
        quotationListError: action.payload,
        quotationListLoading: false,
      };
    case types.GET_QUOTATION_RESET:
      return {
        ...state,
        quotationListError: null,
        quotationListLoading: false,
      };
    //create

    case types.CREATE_QUOTATION_START:
      return {
        ...state,
        createquotation: null,
        createquotationError: null,
        createquotationLoading: true,
      };
    case types.CREATE_QUOTATION_SUCCESS:
      return {
        ...state,
        createquotation: action.payload,
        createquotationLoading: false,
      };
    case types.CREATE_QUOTATION_ERROR:
      return {
        ...state,
        createquotationError: action.payload,
        createquotationLoading: false,
      };
    case types.CREATE_QUOTATION_RESET:
      return {
        ...state,
        createquotationError: null,
        createquotationLoading: false,
      };
    //delete

    case types.DELETE_QUOTATION_START:
      return {
        ...state,
        deletequotation: null,
        deletequotationError: null,
        deletequotationLoading: true,
      };
    case types.DELETE_QUOTATION_SUCCESS:
      return {
        ...state,
        deletequotation: action.payload,
        deletequotationLoading: false,
      };
    case types.DELETE_QUOTATION_ERROR:
      return {
        ...state,
        deletequotationError: action.payload,
        deletequotationLoading: false,
      };
    case types.DELETE_QUOTATION_RESET:
      return {
        ...state,
        deletequotation: null,
        deletequotationError: null,
        deletequotationLoading: false,
      };

    //update
    case types.UPDATE_QUOTATION_START:
      return {
        ...state,
        updatequotation: null,
        updatequotationError: null,
        updatequotationLoading: true,
      };
    case types.UPDATE_QUOTATION_SUCCESS:
      return {
        ...state,
        updatequotation: action.payload,
        updatequotationLoading: false,
      };
    case types.UPDATE_QUOTATION_ERROR:
      return {
        ...state,
        updatequotationError: action.payload,
        updatequotationLoading: false,
      };
    case types.UPDATE_QUOTATION_RESET:
      return {
        ...state,
        updatequotation: null,
        updatequotationError: null,
        updatequotationLoading: false,
      };
    //singleItem
    case types.SINGLE_QUOTATION_START:
      return {
        ...state,
        singleItem: null,
        singleItemError: null,
        singleItemLoading: true,
      };
    case types.SINGLE_QUOTATION_SUCCESS:
      return {
        ...state,
        singleItem: action.payload,
        singleItemLoading: false,
      };
    case types.SINGLE_QUOTATION_ERROR:
      return {
        ...state,
        singleItemError: action.payload,
        singleItemLoading: false,
      };
    case types.SINGLE_QUOTATION_RESET:
      return {
        ...state,
        singleItem: null,
        singleItemError: null,
        singleItemLoading: false,
      };

    default:
      return { ...state };
  }
};

export default quotationReducer;

